import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'

@Component({
  selector: 'app-pdf-viewer',
  styles: [':host { flex: 1; min-height: 0; display: block; }'],
  template: `
    <ngx-extended-pdf-viewer
      *ngIf="pdfBlob"
      [src]="pdfBlob"
      [showToolbar]="true"
      [showSidebarButton]="false"
      [showBorders]="false"
      [showDownloadButton]="false"
      [showPrintButton]="false"
      [showOpenFileButton]="false"
      [showPropertiesButton]="false"
      [showSecondaryToolbarButton]="false"
      [showRotateButton]="false"
      [showDrawEditor]="false"
      [showTextEditor]="false"
      [showStampEditor]="false"
      [textLayer]="true"
      [pageViewMode]="'infinite-scroll'"
      [height]="'100%'"
    ></ngx-extended-pdf-viewer>
  `,
})
export class PdfViewerComponent implements OnChanges {
  @Input() pdfBlob!: Blob

  ngOnChanges(changes: SimpleChanges): void {}
}
